/**
 * Whether a transfer is worth offering on this order at all.
 *
 * **What this file used to be, and where it went.** It carried the whole of §9.6's door-QR flow -
 * `qrDataOf`, `payabilityProblems`, `mayPoll`, `waitingNote`, `confirmNote`, `confirmPayload`,
 * `resultNote` and `askNote` - because the driver had to be told, at a door, that the code might be
 * unpayable and that their own *Zaplatil* was being stored as their word rather than as a
 * confirmation. FB-186 measured why all three were needed:
 *
 * 1. the stored payee IBAN **fails mod-97** (`SK14…` where the account requires check digits `55`),
 *    so a customer's banking app refuses the transfer;
 * 2. `tb_auto_verify` is `false` with no token and no account id, so the status endpoint answers
 *    *not paid* for ever;
 * 3. `confirm` wrote the same `qr_paid` for a driver's word as for a verified payment.
 *
 * **§9.338 / `BACKEND.md` §10A.127 replaced the flow**, so those eight went with it. The driver's
 * button now opens a real TatraPay session with the same credentials CardPay uses - the bank answers,
 * there is no IBAN in the code to be wrong, and there is no word to qualify. `transfer.ts` is what
 * the sheet reads.
 *
 * This one function survives because the question it answers has not changed.
 */

/**
 * Only where the customer still owes the driver money.
 *
 * An order already settled online, or paid by card at the door, has nothing to transfer - offering
 * one would take the money twice. The server refuses the same three in
 * `DoorTransferService.OWES_MONEY`, so a button that got past this is still refused rather than
 * charging somebody; this is what stops it being offered in the first place.
 */
export function offersQr(paymentMethod: string, isActive: boolean): boolean {
  if (!isActive) return false
  return paymentMethod === 'cash' || paymentMethod === 'card_courier' || paymentMethod === ''
}
